import { CommonMessage } from '@frontend/lang';
import { FormattedMessage } from 'react-intl';

import { ParallelConfirmOpenSlotsScreen } from '../confirm-open-slots-shared/parallel-confirm-open-slots-screen.component';
import usePickUpConfirmOpenSlotsParallel from './pick-up-confirm-open-slots-parallel.controller';

const ID = 'pick-up-confirm-open-slots-parallel';

const PickUpConfirmOpenSlotsParallel = () => {
    const viewProps = usePickUpConfirmOpenSlotsParallel();

    return (
        <ParallelConfirmOpenSlotsScreen
            id={ID}
            headerTitle={CommonMessage.BUTTONS.PICK_UP}
            viewProps={viewProps}
            openSlotsLabel={
                <FormattedMessage
                    id='kiosk.wizard.pick-up-confirm-open-slots-parallel.open-slots'
                    defaultMessage='Open SLOTs'
                    description='Button to open all pick-up SLOTs for the selected collis in parallel'
                />
            }
        />
    );
};

export default PickUpConfirmOpenSlotsParallel;
